import {Button} from '@primer/react'
import {useNavigate} from '@github-ui/use-navigate'
import {repoPromptNewPath} from '@github-ui/paths'
import {useParams} from 'react-router-dom'
import type {ModelState} from '../../../types'

export function CreatePromptFileButton({modelState}: {modelState: ModelState}) {
  const {owner, repo} = useParams<{
    owner: string
    repo: string
  }>()

  const navigate = useNavigate()

  const handleCreatePromptFile = () => {
    if (!owner || !repo) return
    const repository = {
      ownerLogin: owner,
      name: repo,
    }
    navigate(repoPromptNewPath(repository), {
      state: {
        params: modelState.parameters,
        model: modelState.catalogData.original_name,
        systemPrompt: modelState.systemPrompt,
      },
    })
  }

  return (
    <>
      <span className="text-small color-fg-muted">Evaluate, test, and share parameters</span>
      <Button onClick={handleCreatePromptFile}>Create prompt.yml file</Button>
    </>
  )
}

try{ CreatePromptFileButton.displayName ||= 'CreatePromptFileButton' } catch {}